"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialPaperCustomDragAndDrop = exports.MaterialPaperDashboard = exports.MaterialPaper = exports.MaterialPaperUnstyled = void 0;
const core_1 = require("@material-ui/core");
const material_ui_1 = require("material-ui");
const Paper_1 = require("material-ui/Paper");
const react_1 = require("react");
const React = require("react");
const decorate = material_ui_1.withStyles(theme => core_1.createStyles({
    root: {
        borderRadius: 0,
        padding: "50px",
        margin: "-20px 100px 40px 100px",
        marginBottom: "10rem"
    },
    noPadding: {
        borderRadius: 0,
        padding: 0,
        margin: "-30px 100px 40px 100px",
        marginBottom: "10rem"
    },
    noMargin: {
        borderRadius: 0,
        padding: 0,
        margin: 0,
        marginBottom: "10rem"
    }
}));
const decorateDashboard = material_ui_1.withStyles(theme => core_1.createStyles({
    root: {
        borderRadius: 0,
        margin: "-20px 100px 40px 100px",
        marginBottom: "10rem"
    },
    noMargin: {
        borderRadius: 0,
        padding: 0,
        margin: 0,
        marginBottom: "10rem"
    },
    noPadding: {
        borderRadius: 0,
        padding: 0,
        marginBottom: "10rem"
    }
}));
const decorateCustomDragAndDrop = material_ui_1.withStyles(theme => core_1.createStyles({
    root: {
        borderRadius: 0,
        padding: "0",
        margin: "0",
        marginBottom: "10rem"
    },
    noPadding: {
        borderRadius: 0,
        padding: 0,
        margin: "0",
        marginBottom: "10rem"
    }
}));
class MaterialPaperUnstyled extends react_1.Component {
    render() {
        const { children, classes, className, noPadding, noMargin } = this.props;
        return (React.createElement(Paper_1.default, { classes: {
                root: noPadding
                    ? classes.noPadding
                    : noMargin
                        ? classes.noMargin
                        : classes.root
            }, className: className, square: true }, children));
    }
}
exports.MaterialPaperUnstyled = MaterialPaperUnstyled;
exports.MaterialPaper = decorate(MaterialPaperUnstyled);
exports.MaterialPaperDashboard = decorateDashboard(MaterialPaperUnstyled);
exports.MaterialPaperCustomDragAndDrop = decorateCustomDragAndDrop(MaterialPaperUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/paper/paper.tsx
// module id = 2788
// module chunks = 0 1